// Traduções pt-BR das strings de autenticação do GetPaid. Paridade total com
// auth.en.ts (a fonte da verdade) — toda chave existe nos dois arquivos.
const auth: Record<string, string> = {
  // -------- Login --------
  'auth.login.title': 'Entrar no GetPaid',
  'auth.login.subtitle': 'Informe seu e-mail e enviaremos um link mágico para entrar.',
  'auth.login.expiredBanner': 'Sua sessão expirou. Entre novamente.',
  'auth.login.referralBanner':
    'Você foi convidado(a) — ganhe 50% de desconto na nossa tarifa no seu primeiro mês.',

  'auth.login.email': 'E-mail',
  'auth.login.emailPlaceholder': 'voce@empresa.com',
  'auth.login.submit': 'Enviar link de acesso por e-mail',
  'auth.login.submitting': 'Enviando link…',

  'auth.login.sent.title': 'Verifique seu e-mail',
  'auth.login.sent.body': 'Enviamos um link de acesso para {email}. O link expira em 15 minutos.',
  'auth.login.sent.tryAgain': 'Usar outro e-mail',

  'auth.login.or': 'ou',
  'auth.login.google': 'Continuar com o Google',
  'auth.login.googleLoading': 'Conectando ao Google…',
  'auth.login.passkey': 'Entrar com uma chave de acesso',
  'auth.login.passkeyLoading': 'Aguardando sua chave de acesso…',

  'auth.login.error.generic': 'Não foi possível entrar. Tente novamente.',
  'auth.login.error.google': 'O login com o Google não funcionou. Tente novamente.',
  'auth.login.error.googleCancelled': 'O login com o Google foi cancelado.',
  'auth.login.error.passkey': 'O login com a chave de acesso não funcionou. Tente novamente.',
  'auth.login.error.passkeyCancelled': 'O login com a chave de acesso foi cancelado.',

  // -------- Consumo do link mágico --------
  'auth.consume.loading': 'Entrando…',
  'auth.consume.error.expired': 'Este link de acesso expirou. Solicite um novo.',
  'auth.consume.error.used': 'Este link de acesso já foi utilizado.',
  'auth.consume.error.invalid': 'Este link de acesso é inválido.',
  'auth.consume.error.generic': 'Não foi possível entrar. Solicite um novo link.',
  'auth.consume.requestNew': 'Solicitar um novo link',
};

export default auth;
